<script lang="ts">
	import Icon from "./Icon.svelte";
	import productArrowDown from "../../../core/assets/icons/product-arrow-down.svg?raw";
	import { flyInOnScroll } from "../utils/flyInOnScroll.js";
	import { nbspify } from "../../../core/utils/nbspify.js";

	export let title: string;
</script>

<div
	use:flyInOnScroll
	class="text-secondary flex w-full justify-between gap-2 bg-[#3A3A3A]/50 py-[1.75rem] pl-8 pr-6 backdrop-blur lg:max-w-[36.25rem] lg:gap-6 xl:w-[36.25rem] xl:pl-[3.625rem]"
>
	<span class="md:text-2md text-[1.125rem]">{nbspify(title)}</span>
	<Icon icon={productArrowDown} class="!aspect-auto h-full" />
</div>
